module.exports = __webpack_public_path__ + "a0cd8e154b217f3549d6bf776a8b752a.jpg";